import React, { Component } from "react";
import { renameLinkedEvents } from "../../Common/placeRename";
import { PLACE_RENAMED_EVENT } from "./RenameFollowUpModal";
import { photoFieldsFromImage } from "../../Common/photoCredit";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./PlaceEditModal.css";
import AlertModal from "./AlertModal";
import ImageDialog from "./ImageDialog";
import PlaceMenu from "../../CommonWeb/PlaceMenu";
import IconsDialog from "./IconsDialog";
import MultiSelectModal from "./MultiSelectModal";
import HTMLEditorModal from "./HTMLEditorModal";
import NotesPreview from "./NotesPreview";

import Place from "../../Models/Place";
import Common, { Settings, SortByEnum, POI_IMAGES, COLORS } from "../../Common/Common";
import HTMLLinksModalClass from "./HTMLLinksModalClass";
import MenuModal from "../modals/MenuModal";
import PromptModal from "../modals/PromptModal";
import SectionsDialog from "../modals/SectionsDialog";
import GroupsDialog from "../modals/GroupsDialog";
import CategoriesDialog from "../modals/CategoriesDialog";
import { countries } from "../../Data/Countries";
import { citiesByCountry } from "../../Data/Cities";
import CommentsSection from "../CommentsSection";
import IdentifyPlace from "./IdentifyPlace";
import MapPickDialog from "./MapPickDialog";
import { reverseGeocodeCoords, findIdentifyCandidates } from "../../Common/placeIdentify";

class PlaceEditModal extends Component {
  // const PlaceEditModal = (props) => {
  // const [name, setName] = useState(props.name);
  // const [multiSelect, setMultiSelect] = useState(false);

  constructor(props) {
    super(props);

    //const place = window.guide_obj.places.getPlace(this.props.id);
    const place = this.props.place;
    const mode = this.props.mode;
    const callback = this.props.callback;
    let type = this.props.type;
    let initialValueName = "";
    let initialValueInfo = "";
    let initialValueLat = "";
    let initialValueLongi = "";
    let initialValueAddress = "";
    let initialValueCity = "";
    let initialValueState = "";
    let initialValueCountry = "";
    let initialValuePhone = "";
    let initialValueEmail = "";
    let initialValueRating = "";
    let initialValueHlink = "";
    let initialCategory = [];
    let initialGroup = [];
    let initialPhoto = "";
    let initialPhoto_m = "";
    let initialPoints = null;
    let initialHidden = false;
    let initialMustSee = false;
    let initialBucketList = false;
    let initialVisited = false;
    let initialFavorite = false;
    let initialDuration = 30;
    let initialBestTime = "";
    let initialOpeningHours = Place.getDefaultOpeningHours();
    let poi_img = "0";
    // let videoLink = "";
    // let videoLinkOffset = 0;
    // let pathLink = "";
    // let pathLinkName = "";
    let Link = { type: "none", value: "", offset: "0" };
    let LinkName = `no link: ${Link.value}`;
    // if (mode == "ADD") {
    //   const text = this.readTextFromClipboard();
    //   if (typeof text == "string") {
    //     if (text.includes("https://www.happycow.net/reviews/")) {
    //       const text_parts = text.split("/");
    //       const name_parts = text_parts[text_parts.length - 1].split("-");
    //       let name = "";
    //       for (let i = 0; i < name_parts.length - 2; i++) name = name + (i == 0) ? name_parts[i] : name_parts[i] + " ";
    //       initialValueName = name;
    //       initialValueHlink = `Happpy Cow|${text}`;
    //       this.copyTextToClipboard("");
    //     }
    //   }
    // }

    if (mode != "ADD") {
      initialValueName = place.Name;
      initialValueInfo = Common.createTextFromHTML(place.Info);
      // A place may have no location (photos without GPS, Wikipedia
      // articles — 2026-10-17): show the fields empty instead of crashing
      // on null.toFixed.
      initialValueLat = typeof place.Lat === "number" && Number.isFinite(place.Lat) ? place.Lat.toFixed(6) : place.Lat == null ? "" : String(place.Lat);
      initialValueLongi = typeof place.Longi === "number" && Number.isFinite(place.Longi) ? place.Longi.toFixed(6) : place.Longi == null ? "" : String(place.Longi);
      initialValueAddress = place.Address;
      initialValueCity = place.City;
      initialValueState = place.State;
      initialValueCountry = place.Country;
      initialValuePhone = place.Phone;
      initialValueEmail = place.Email;
      initialValueRating = place.Rating.toString();
      initialValueHlink = place.Hlink;
      initialCategory = place.Category;
      initialGroup = place.Group;
      initialPhoto = place.Photo;
      initialPhoto_m = place.Photo_m;
      // The photo's print size and credit, if it's a stock photo (kept with
      // the photo — Common/photoCredit.js).
      this._photoExtras = { PhotoPrint: place.PhotoPrint, PhotoCredit: place.PhotoCredit };
      initialPoints = place.Points;
      initialDuration = 30;
      poi_img = place.poi_img;

      if (typeof place.Duration == "undefined") initialDuration = 30;
      else initialDuration = place.Duration;
      if (Place.BEST_TIMES.includes(place.BestTime)) initialBestTime = place.BestTime;
      type = place.PType;
      if (typeof place.Hidden == "undefined") initialHidden = false;
      else initialHidden = place.Hidden;
      if (typeof place.MustSee == "undefined") initialMustSee = false;
      else initialMustSee = place.MustSee;
      if (typeof place.BucketList == "undefined") initialBucketList = false;
      else initialBucketList = place.BucketList;
      if (typeof place.Visited == "undefined") initialVisited = false;
      else initialVisited = place.Visited;
      if (typeof place.Favorite == "undefined") initialFavorite = false;
      else initialFavorite = place.Favorite;
      initialOpeningHours = Place.mergeOpeningHoursDefaults(place.OpeningHours);
      if (typeof place.Link == "undefined") Link = { type: "none", value: "", offset: "0" };
      else Link = place.Link;
      if (Link.type === "path") {
        const path_place = window.guide_obj.places.getPlace(Link.value);
        if (path_place !== null) LinkName = `${place.Link.type} link: ${path_place.Name}`;
      } else if (Link.type === "section") {
        const section = window.guide_obj.findSection(place.Link.value);
        if (section !== null) LinkName = `${place.Link.type} link: ${section.Title}`;
      } else if (Link.type === "none") {
        LinkName = `no link:`;
      } else LinkName = `${Link.type} link: ${Link.value}`;
    }
    this.state = {
      textValueName: initialValueName,
      textValueInfo: initialValueInfo,
      textValueInfoUpdate: initialValueInfo,
      textValueLat: initialValueLat,
      textValueLongi: initialValueLongi,
      textValueAddress: initialValueAddress,
      textValueCity: initialValueCity,
      textValueState: initialValueState,
      textValueCountry: initialValueCountry,
      textValuePhone: initialValuePhone,
      textValueEmail: initialValueEmail,
      textValueRating: initialValueRating,
      textValueDuration: initialDuration,
      BestTime: initialBestTime,
      Categories: initialCategory,
      Groups: initialGroup,
      textValueHlink: initialValueHlink,
      Photo: initialPhoto,
      Photo_m: initialPhoto_m,
      type: type,
      Points: initialPoints,
      Hidden: initialHidden,
      MustSee: initialMustSee,
      BucketList: initialBucketList,
      Visited: initialVisited,
      Favorite: initialFavorite,
      OpeningHours: initialOpeningHours,
      poi_img: poi_img,
      callback: callback,
      Link: Link,
      LinkName: LinkName,

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      MultiselectOnEdit: null,
      ShowMultiselect: false,
      ShowGroupsDialog: false,
      ShowCategoriesDialog: false,

      IconsDialogShow: false,
      ImageDialogShow: false,
      ShowHTMLEditorModal: false,
      ShowHTMLLinks: false,

      MenuModalShow: false,
      MenuModalImage: null,
      MenuModalList: [],
      MenuModalHeading: "",
      MenuModalPlace: null,

      PromptModalShow: false,
      PromptModalTitle: "Enter Value",
      PromptModalMessage: "",
      PromptModalButtons: [],
      PromptModalInputs: [],
      SectionsDialogShow: false,
    };
    this.handleChangeTextName = this.handleChangeTextName.bind(this);
    this.handleChangeTextInfo = this.handleChangeTextInfo.bind(this);
    this.handleChangeTextLat = this.handleChangeTextLat.bind(this);
    this.handleChangeTextLongi = this.handleChangeTextLongi.bind(this);
    this.handleChangeTextAddress = this.handleChangeTextAddress.bind(this);
    this.handleChangeTextState = this.handleChangeTextState.bind(this);
    this.handleChangeTextCountry = this.handleChangeTextCountry.bind(this);
    this.handleChangeTextPhone = this.handleChangeTextPhone.bind(this);
    this.handleChangeTextPhone = this.handleChangeTextPhone.bind(this);
    this.handleChangeTextEmail = this.handleChangeTextEmail.bind(this);
    this.handleChangeTextRating = this.handleChangeTextRating.bind(this);
    this.handleChangeTextHlink = this.handleChangeTextHlink.bind(this);
    this.handleChangeTextPhoto = this.handleChangeTextPhoto.bind(this);
    this.handleChangeTextDuration = this.handleChangeTextDuration.bind(this);
    this.handleChangeVideoLink = this.handleChangeVideoLink.bind(this);
    this.handleChangeVideoLinkOffset = this.handleChangeVideoLinkOffset.bind(this);
    //https://www.happycow.net/reviews/a-casa-ca-fe-florence-150794
  }
  componentDidMount() {
    // Lets a caller (e.g. Schedule's opening-hours-conflict warning badge)
    // land the user directly on the Opening Hours section instead of the
    // top of this long form — the modal's own entrance animation needs a
    // beat before the section is actually scrollable.
    if (this.props.scrollToOpeningHours) {
      setTimeout(() => {
        const el = document.getElementById("pem-opening-hours-section");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 250);
    }
  }
  handleChangeTextName = (newText) => {
    this.setState({ ...this.state, textValueName: newText });
  };
  handleChangeTextInfo = (newText) => {
    this.setState({ ...this.state, textValueInfo: newText });
  };
  handleChangeTextLat = (newText) => {
    this.setState({ ...this.state, textValueLat: newText });
  };
  handleChangeTextLongi = (newText) => {
    this.setState({ ...this.state, textValueLongi: newText });
  };
  handleChangeTextAddress = (newText) => {
    this.setState({ ...this.state, textValueAddress: newText });
  };
  handleChangeTextState = (newText) => {
    this.setState({ ...this.state, textValueState: newText });
  };
  handleChangeTextCountry = (newText) => {
    this.setState({ ...this.state, textValueCountry: newText });
  };
  handleChangeTextPhone = (newText) => {
    this.setState({ ...this.state, textValuePhone: newText });
  };
  handleChangeTextEmail = (newText) => {
    this.setState({ ...this.state, textValueEmail: newText });
  };
  handleChangeTextRating = (newText) => {
    if (isNaN(newText)) {
      if (newText != "") newText = "";
    }
    const rating = parseInt(newText);
    if (rating < 0 || rating > 5) newText = "";
    this.setState({ ...this.state, textValueRating: newText });
  };

  handleChangeVideoLinkOffset = (newText) => {
    if (isNaN(newText)) {
      if (newText !== "") newText = "";
    }
    const link = { ...this.state.Link, offset: newText };
    this.setState({ ...this.state, Link: link });
  };

  handleChangeVideoLink = (newText) => {
    this.setState({ ...this.state, videoLink: newText });
  };

  handleChangeTextHlink = (newText) => {
    this.setState({ ...this.state, textValueHlink: newText });
  };
  handleChangeTextPhoto = (newText) => {
    //console.log("handleChangeTextPhoto", newText);
    this.setState({ Photo: newText });
  };
  handleChangeTextDuration = (newText) => {
    if (isNaN(newText)) {
      if (newText !== "") newText = "";
    }
    this.setState({ textValueDuration: newText });
  };

  handleToggleOpeningHoursClosed = (day) => {
    this.setState({
      OpeningHours: {
        ...this.state.OpeningHours,
        [day]: { ...this.state.OpeningHours[day], closed: !this.state.OpeningHours[day].closed },
      },
    });
  };

  handleAddOpeningHoursPeriod = (day) => {
    const dayHours = this.state.OpeningHours[day];
    this.setState({
      OpeningHours: {
        ...this.state.OpeningHours,
        [day]: { ...dayHours, periods: [...dayHours.periods, { open: "", close: "" }] },
      },
    });
  };

  handleRemoveOpeningHoursPeriod = (day, index) => {
    const dayHours = this.state.OpeningHours[day];
    this.setState({
      OpeningHours: {
        ...this.state.OpeningHours,
        [day]: { ...dayHours, periods: dayHours.periods.filter((_, i) => i !== index) },
      },
    });
  };

  handleChangeOpeningHoursPeriod = (day, index, field, value) => {
    const dayHours = this.state.OpeningHours[day];
    const periods = dayHours.periods.map((p, i) => (i === index ? { ...p, [field]: value } : p));
    this.setState({
      OpeningHours: { ...this.state.OpeningHours, [day]: { ...dayHours, periods } },
    });
  };

  // copyTextToClipboard = (text) => {
  //   Clipboard.setString(text);
  // };

  // readTextFromClipboard = async () => {
  //   const text = await Clipboard.getString();
  //   return text;
  // };

  MyAlert = (message) => {
    this.setState({
      AlertModalTitle: "Message",
      AlertModalMessage: message,
      AlertModalButtons: [{ Title: "OK", Method: null }],
      AlertModalShow: true,
    });
  };

  AddPlace = () => {
    if (this.state.textValueName == "") {
      this.MyAlert("Must specify Name");
      return;
    }
    // Both blank = a place with no map location (photos without GPS,
    // Wikipedia articles — 2026-10-17); one blank or not a number is still
    // an error.
    // Not a real number (blank, or "NaN"/"undefined" left by older data)
    // counts as blank, so a place without a location always saves
    // (2026-10-18: one still hit "Must specify Latitude and Longitude").
    const notNumber = (v) => { const t = String(v ?? "").trim(); return t === "" || !Number.isFinite(Number(t)); };
    const latBlank = notNumber(this.state.textValueLat);
    const lngBlank = notNumber(this.state.textValueLongi);
    const noLocation = latBlank && lngBlank && this.state.Points == null;
    if (!noLocation && (latBlank || isNaN(this.state.textValueLat)) && this.state.Points == null) {
      this.MyAlert("Must specify Latitude and Longitude (or leave both blank for a place without a map location)");
      return;
    }
    if (!noLocation && (lngBlank || isNaN(this.state.textValueLongi)) && this.state.Points == null) {
      this.MyAlert("Must specify Latitude and Longitude (or leave both blank for a place without a map location)");
      return;
    }
    if (this.state.textValueRating != "" && isNaN(this.state.textValueRating)) {
      this.MyAlert("Rating must be blank or a number");
      return;
    }
    const mode = this.props.mode;
    const old_place = this.props.place;
    //console.log("AddPlace", mode);
    let new_place = new Place(window.guide_obj.places);
    if (mode == "ADD") {
      new_place.Name = this.state.textValueName;
      new_place.Info = this.state.textValueInfoUpdate;
      new_place.Lat = noLocation ? "" : parseFloat(this.state.textValueLat);
      new_place.Longi = noLocation ? "" : parseFloat(this.state.textValueLongi);
      new_place.Address = this.state.textValueAddress;
      new_place.City = this.state.textValueCity;
      new_place.State = this.state.textValueState;
      new_place.Country = this.state.textValueCountry;
      new_place.Phone = this.state.textValuePhone;
      new_place.Email = this.state.textValueEmail;
      new_place.Rating = this.state.textValueRating == "" ? "" : parseFloat(this.state.textValueRating);
      new_place.Hlink = this.state.textValueHlink;
      new_place.Category = this.state.Categories;
      new_place.Group = this.state.Groups;
      new_place.Photo = this.state.Photo;
      new_place.Photo_m = this.state.Photo_m;
      this._applyPhotoExtras(new_place);
      new_place.PType = this.state.type;
      new_place.Points = this.state.Points;
      new_place.Hidden = this.state.Hidden;
      new_place.MustSee = this.state.MustSee;
      new_place.BucketList = this.state.BucketList;
      new_place.Visited = this.state.Visited;
      new_place.Favorite = this.state.Favorite;
      new_place.poi_img = this.state.poi_img;
      new_place.Duration = this.state.textValueDuration === "" ? 30 : parseInt(this.state.textValueDuration);
      Place.setBestTime(new_place, this.state.BestTime);
      //new_place.pathLink = this.state.pathLink;
      new_place.Link = this.state.Link;
      new_place.OpeningHours = this.state.OpeningHours;
      //new_place.pathLinkName = this.state.pathLinkName;
      //new_place.videoLink = this.state.videoLink;
      //new_place.videoLinkOffset = this.state.videoLinkOffset;

      //console.log("new_place", new_place);
      // this.props.onAddPlace(new_place);
      window.guide_obj.places.addPlace(new_place);
      if (this.state.callback != null) this.state.callback(new_place);
    } else {
      const oldName = old_place.Name;
      old_place.Name = this.state.textValueName;
      old_place.Info = this.state.textValueInfoUpdate;
      old_place.Lat = noLocation ? "" : parseFloat(this.state.textValueLat);
      old_place.Longi = noLocation ? "" : parseFloat(this.state.textValueLongi);
      old_place.Address = this.state.textValueAddress;
      old_place.City = this.state.textValueCity;
      old_place.State = this.state.textValueState;
      old_place.Country = this.state.textValueCountry;
      old_place.Phone = this.state.textValuePhone;
      old_place.Email = this.state.textValueEmail;
      old_place.Rating = this.state.textValueRating == "" ? "" : parseFloat(this.state.textValueRating);
      old_place.Hlink = this.state.textValueHlink;
      old_place.Category = this.state.Categories;
      old_place.Group = this.state.Groups;
      old_place.Photo = this.state.Photo;
      old_place.Photo_m = this.state.Photo_m;
      this._applyPhotoExtras(old_place);
      // A cleared photo stays cleared: remember it so bulk photo refreshes skip it.
      PlaceMenu.setNoGoodPhoto(old_place, !this.state.Photo && !this.state.Photo_m);
      old_place.PType = this.state.type;
      old_place.Points = this.state.Points;
      old_place.Hidden = this.state.Hidden;
      old_place.MustSee = this.state.MustSee;
      old_place.BucketList = this.state.BucketList;
      old_place.Visited = this.state.Visited;
      old_place.Favorite = this.state.Favorite;
      old_place.poi_img = this.state.poi_img;
      const typedDuration = this.state.textValueDuration === "" ? 30 : parseInt(this.state.textValueDuration);
      // A length the user changed is the place's own from now on.
      if (typedDuration !== old_place.Duration) delete old_place.DurationUnset;
      old_place.Duration = typedDuration;
      // Best time of day: used when a day's stops are put in order (Schedule.js).
      Place.setBestTime(old_place, this.state.BestTime);
      old_place.Link = this.state.Link;
      old_place.OpeningHours = this.state.OpeningHours;
      //old_place.pathLink = this.state.pathLink;
      //old_place.pathLinkName = this.state.pathLinkName;
      //old_place.videoLink = this.state.videoLink;
      //old_place.videoLinkOffset = this.state.videoLinkOffset;
      //console.log(old_place);
      window.guide_obj.places.modifyPlace(old_place, old_place.ID);
      // Renamed (4.10.55): its events with exactly the old title follow; the
      // itinerary is only changed if the person says so (RenameFollowUpModal).
      if ((oldName || "").trim() && (oldName || "").trim() !== (old_place.Name || "").trim()) {
        const renamedEvents = renameLinkedEvents(window.guide_obj.schedule?.events, old_place.ID, oldName, old_place.Name);
        window.dispatchEvent(new CustomEvent(PLACE_RENAMED_EVENT, { detail: { oldName: oldName.trim(), newName: old_place.Name.trim(), renamedEvents } }));
      }
    }
    this.props.update_display();
    this.exitDialog();
  };

  selectCategories = () => {
    //console.log("selectCategories");
    let selectedCategories = [];
    let cats = window.guide_obj.categoryObjectArrayFromIDArray(this.state.Categories);
    cats.forEach((cat) =>
      selectedCategories.push({
        label: cat.name,
        value: cat,
      })
    );
    this.MultiSelect(
      window.guide_obj.getCategoriesToDisplay(),
      selectedCategories,
      "multi",
      this.selectCategoriesCallBack,
      "Select Categories",
      () => this.setState({ ShowMultiselect: false, ShowCategoriesDialog: true })
    );
  };

  selectCategoriesCallBack = (Categories) => {
    let cats = [];
    Categories.forEach((Category) => {
      cats.push(Category.value.id);
    });
    this.setState({ ...this.state, Categories: cats });
  };

  selectGroups = () => {
    let selectedGroups = [];
    let groups = window.guide_obj.groupObjectArrayFromIDArray(this.state.Groups);
    groups.forEach((group) =>
      selectedGroups.push({
        label: group.name,
        value: group,
      })
    );
    this.MultiSelect(
      window.guide_obj.getGroupsToDisplay(),
      selectedGroups,
      "multi",
      this.selectGroupsCallBack,
      "Select Groups",
      () => this.setState({ ShowMultiselect: false, ShowGroupsDialog: true })
    );
  };

  selectGroupsCallBack = (Groups) => {
    //console.log(Groups);
    let groups = [];
    Groups.forEach((Group) => {
      groups.push(Group.value.id);
    });
    this.setState({ ...this.state, Groups: groups });
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title, OnEdit = null) => {
    console.log("MultiSelect");
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      MultiselectOnEdit: OnEdit,
      ShowMultiselect: true,
    });
  };

  showMapDialog = () => {
    const mode = this.props.navigation.getParam("mode", "");
    let initialCoordinate = {
      latitude: parseFloat(this.state.textValueLat),
      longitude: parseFloat(this.state.textValueLongi),
    };
    if (mode == "ADD") initialCoordinate = null;
    ////console.log(
    //   "this.state.textValueLat, this.state.textValueLongi",
    //   this.state.textValueLat,
    //   this.state.textValueLongi
    // );
    // if (
    //   !isNaN(this.state.textValueLat) &&
    //   !isNaN(this.state.textValueLongi) &&
    //   this.state.textValueLat != "" &&
    //   this.state.textValueLongi != ""
    // ) {
    //   initialCoordinate = {
    //     latitude: parseFloat(this.state.textValueLat),
    //     longitude: parseFloat(this.state.textValueLongi),
    //   };
    // }
    //console.log("initialCoordinate", initialCoordinate);
    window.guide_obj.onGetMapToDisplay();
    //console.log(initialCoordinate);
    //console.log("showMapDialog", this.state.type);
    this.props.navigation.navigate("MapDialog", {
      updateCoordinate: this.updateCoordinate,
      initialCoordinate: initialCoordinate,
      type: this.state.type,
      initialPoints: this.state.Points,
    });
  };

  updateCoordinate = (coordinate, path) => {
    if (path == null)
      this.setState({ textValueLat: coordinate.latitude.toFixed(6), textValueLongi: coordinate.longitude.toFixed(6) });
    else {
      this.setState({ Points: path });
    }
  };

  changeImage = () => {
    this.setState({
      ImageDialogShow: true,
      mode: "select",
      size: "medium",
      multi: false,
      updateImage: this.updateImageCallBack,
      name: this.state.textValueName,
      Photo: this.state.Photo,
      Photo_m: this.state.Photo_m,
    });
  };

  updateImageCallBack = (imageInfo) => {
    if (!imageInfo || imageInfo.length === 0) return;
    this._photoExtras = photoFieldsFromImage(imageInfo[0]);
    this.setState({ Photo: imageInfo[0].url, Photo_m: imageInfo[0].url_m });
  };

  _applyPhotoExtras = (place) => {
    const x = this._photoExtras || {};
    if (x.PhotoPrint) place.PhotoPrint = x.PhotoPrint;
    else delete place.PhotoPrint;
    if (x.PhotoCredit) place.PhotoCredit = x.PhotoCredit;
    else delete place.PhotoCredit;
  };

  editInfo = () => {
    this.setState({ ShowHTMLEditorModal: true });
    // this.props.navigation.navigate("HTMLEditor", { html: this.state.textValueInfo, callback: this.editInfoCallback });
  };

  editInfoCallback = (html) => {
    this.setState({ textValueInfoUpdate: html });
  };

  formatLatLong = (textValue) => {
    if (textValue == "") return "";
    return `${parseFloat(textValue).toFixed(6)}`;
  };

  updateHidden = () => {
    this.setState({ Hidden: !this.state.Hidden });
  };

  updateMustSee = () => {
    this.setState({ MustSee: !this.state.MustSee });
  };

  updateVisited = () => {
    this.setState({ Visited: !this.state.Visited });
  };

  updateFavorite = () => {
    this.setState({ Favorite: !this.state.Favorite });
  };

  changeIcon = () => {
    this.setState({ IconsDialogShow: true });
  };

  changeIconCallback = (poi_img) => {
    console.log(poi_img);
    let _poi_img = poi_img.id;
    if (typeof poi_img.obj !== "undefined") if (typeof poi_img.obj.url !== "undefined") _poi_img = poi_img.obj.url;
    this.setState({ poi_img: _poi_img });
  };

  HiddenChanged = () => {
    this.setState({ Hidden: !this.state.Hidden });
  };

  VisitedChanged = () => {
    this.setState({ Visited: !this.state.Visited });
  };

  FavoriteChanged = () => {
    this.setState({ Favorite: !this.state.Favorite });
  };

  MustSeeChanged = () => {
    this.setState({ MustSee: !this.state.MustSee });
  };

  BucketListChanged = () => {
    this.setState({ BucketList: !this.state.BucketList });
  };

  // getImageURLString = (str) => {
  //   console.log("BEFORE", str);
  //   const url = Common.getImageURL(str);
  //   console.log("AFTER", url);
  //   return url;
  // };

  getImageURLString = (str) => {
    // console.log("BEFORE", str);
    const img = Common.getImageURL(str, Common.getFBPath(null, this.props.user_info), true);
    // console.log("AFTER", img);
    return img;
  };

  exitDialog = () => {
    if (typeof this.props.onHidePrevious != "undefined") this.props.onHidePrevious();
    this.props.onHide();
  };

  _renderRow = (label, iconNode, value, onPress) => (
    <div className="pem-row-item" onClick={onPress}>
      <span className="pem-row-icon">{iconNode}</span>
      <span className="pem-row-key">{label}</span>
      {value ? <span className="pem-row-value">{value}</span> : null}
      <span className="pem-row-chevron"><FontAwesomeIcon icon={solid("chevron-right")} /></span>
    </div>
  );

  // Identify a place already in the guide (4.10.55, 2026-10-26) — e.g. one
  // still named after a photo file: the same nearby suggestions, city and
  // "Pick on the map" as Review Places; a pick becomes the name (still
  // editable, saved with Save).
  _identifyCoords = () => {
    const lat = parseFloat(this.state.textValueLat);
    const lng = parseFloat(this.state.textValueLongi);
    return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0) ? { lat, lng } : null;
  };

  _runIdentify = async () => {
    const c = this._identifyCoords();
    if (!c) return;
    this.setState({ identify: { status: "loading" }, nameBeforeIdentify: this.state.textValueName });
    const [{ city }, candidates] = await Promise.all([reverseGeocodeCoords(c.lat, c.lng), findIdentifyCandidates(c.lat, c.lng)]);
    this.setState({ identify: { status: "done", city, candidates, pickedTitle: null } });
  };

  _pickIdentifiedName = (title) => {
    if (!title) return;
    this.setState((prev) => ({ textValueName: title, identify: prev.identify ? { ...prev.identify, pickedTitle: title } : prev.identify }));
  };

  // Cancel: close the suggestions and put back the name from before "Identify".
  _cancelIdentify = () => {
    this.setState((prev) => ({ identify: null, textValueName: prev.nameBeforeIdentify ?? prev.textValueName }));
  };

  _renderIdentify = () => {
    if (!this._identifyCoords()) return null;
    return (
      <div className="pem-identify" style={{ padding: "0 12px 10px" }}>
        <IdentifyPlace
          state={this.state.identify}
          onRun={this._runIdentify}
          onPick={this._pickIdentifiedName}
          onPickOnMap={() => this.setState({ mapPick: true })}
          onCancel={this.state.identify ? this._cancelIdentify : null}
        />
      </div>
    );
  };

  _renderInput = (label, value, onChange, placeholder = "") => (
    <div className="pem-input-row">
      <span className="pem-input-label">{label}</span>
      <input
        className="pem-input-field"
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );

  _renderCheck = (label, checked, onPress) => (
    <div className="pem-check-row" onClick={onPress}>
      <div className={`pem-check-box${checked ? " checked" : ""}`}>
        {checked && <FontAwesomeIcon icon={solid("check")} />}
      </div>
      <span className="pem-check-label">{label}</span>
    </div>
  );

  _renderOpeningHoursRow = (day) => {
    const hours = this.state.OpeningHours[day] || { periods: [], closed: false };
    return (
      <div className="pem-oh-day-block" key={day}>
        <div className="pem-oh-day-header">
          <span className="pem-oh-day-label">{day}</span>
          {this._renderCheck("Closed", hours.closed, () => this.handleToggleOpeningHoursClosed(day))}
        </div>
        {!hours.closed && (
          <>
            {hours.periods.map((period, index) => (
              <div className="pem-oh-period-row" key={index}>
                <input
                  className="pem-oh-time-input"
                  type="time"
                  value={period.open}
                  onChange={(e) => this.handleChangeOpeningHoursPeriod(day, index, "open", e.target.value)}
                  aria-label={`${day} open time ${index + 1}`}
                />
                <span className="pem-oh-dash">–</span>
                <input
                  className="pem-oh-time-input"
                  type="time"
                  value={period.close}
                  onChange={(e) => this.handleChangeOpeningHoursPeriod(day, index, "close", e.target.value)}
                  aria-label={`${day} close time ${index + 1}`}
                />
                <span
                  className="pem-oh-remove-btn"
                  onClick={() => this.handleRemoveOpeningHoursPeriod(day, index)}
                  role="button"
                  aria-label={`Remove ${day} time ${index + 1}`}
                >
                  <FontAwesomeIcon icon={solid("circle-xmark")} />
                </span>
              </div>
            ))}
            <div
              className="pem-oh-add-btn"
              onClick={() => this.handleAddOpeningHoursPeriod(day)}
              role="button"
              aria-label={`Add ${day} time`}
            >
              <FontAwesomeIcon icon={solid("circle-plus")} />
              <span>Add time</span>
            </div>
          </>
        )}
      </div>
    );
  };

  createPlaceLinkMenu = () => {
    let menuList = [
      {
        label: "Remove link",
        method: this.removeLink,
        icon: null,
        visible: true,
        checked: false,
        info: "Remove link from place",
      },
      {
        label: "Link to Path",
        method: this.setPathLink,
        icon: null,
        visible: true,
        checked: false,
        info: "Get link to a path which has time location info and associated video",
        videoKey: "link-a-place-to-a-path-and-video",
      },
      {
        label: "Link to Video",
        method: this.setVideoLink,
        icon: null,
        visible: true,
        checked: false,
        info: "Set a link to a video.",
      },
      {
        label: "Link to Audio",
        method: this.setAudioLink,
        icon: null,
        visible: true,
        checked: false,
        info: "Set a link to a audio.",
      },
      {
        label: "Link to Section (HTML)",
        method: this.selectSection,
        icon: null,
        visible: true,
        checked: false,
        info: "Set a link to a section which contains user customized HTML.",
      },
      {
        label: "Link to URL",
        method: this.setURLLink,
        icon: null,
        visible: true,
        checked: false,
        info: "Set a link to a URL i.e. web page e.g. https://google.com",
      },
    ];
    this.setState({ MenuModalList: menuList, MenuModalHeading: "Place Link Menu", MenuModalShow: true });
  };

  removeLink = () => {
    this.setState({ Link: { type: "none", value: "", offset: "0" }, LinkName: `no link:` });
  };

  setPathLink = () => {
    const places = window.guide_obj.places.getPlacesToDisplay(null, "PolyLine");
    this.MultiSelect(places, [], "uni", this.setPathLinkCallBack, "Places");
  };

  setPathLinkCallBack = (Places) => {
    if (Places.length < 1) return;
    const place = Places[0];
    console.log("pathLink", place.value, place.name);
    this.setState({ Link: { type: "path", value: place.value, offset: "0" }, LinkName: `path link: ${place.name}` });
  };

  setVideoLink = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Video",
      PromptModalMessage: "Enter video URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.setVideoLinkCallBack },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Video URL", value: "" }],
    });
  };

  setVideoLinkCallBack = (inputs) => {
    if (inputs.length < 1) return;
    console.log("video", inputs[0].value, inputs[0].name);
    this.setState({
      Link: { type: "video", value: inputs[0].value, offset: "0" },
      LinkName: `video link: ${inputs[0].value}`,
    });
  };

  setAudioLink = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "Audio",
      PromptModalMessage: "Enter audio URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.setAudioLinkCallBack },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "Audio URL", value: "" }],
    });
  };

  setAudioLinkCallBack = (inputs) => {
    if (inputs.length < 1) return;
    console.log("audio", inputs[0].value, inputs[0].name);
    this.setState({
      Link: { type: "audio", value: inputs[0].value, offset: "0" },
      LinkName: `audio link: ${inputs[0].value}`,
    });
  };

  setURLLink = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "URL",
      PromptModalMessage: "Enter URL",
      PromptModalButtons: [
        { Title: "OK", Method: this.setURLLinkCallBack },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "URL", value: "" }],
    });
  };

  setURLLinkCallBack = (inputs) => {
    if (inputs.length < 1) return;
    console.log("url", inputs[0].value, inputs[0].name);
    this.setState({
      Link: { type: "url", value: inputs[0].value, offset: "0" },
      LinkName: `url link: ${inputs[0].value}`,
    });
  };

  selectSection = () => {
    this.setState({ SectionsDialogShow: true });
  };

  selectSectionCallBack = (section) => {
    console.log("section", section.ID, section.Title);
    this.setState({ Link: { type: "section", value: section.ID, offset: "0" }, LinkName: section.Title });
  };

  selectLink = () => {
    this.setState({ ShowHTMLLinks: true });
  };

  insertLinkCallback = (link) => {
    console.log("insertLinkCallback", link.text, link.url);
    this.setState({ textValueHlink: `${link.text}|${link.url}` });
  };

  ReverseGeocode = async () => {
    console.log("ReverseGeocode")
    fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=37.7749,-122.4194&key=${process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_KEY}`)
    .then(function (a) {
      return a.json(); // call the json method on the response to get JSON
  })
  .then(function (json) {
      console.log(json)
        
        try{
        let city = "";
        let state = "";
        let country = "";
        let street_address = "";
        for (var j=0; j<json.results.length; j++)
        {
            for (var i=0; i<json.results[j].address_components.length; i++)
            {
                if (json.results[j].address_components[i].types.includes("locality")) 
                    city = json.results[j].address_components[i].long_name;
                if (json.results[j].address_components[i].types.includes("administrative_area_level_1" ))
                    state = json.results[j].address_components[i].long_name;
                if (json.results[j].address_components[i].types.includes("country"))
                    country = json.results[j].address_components[i].long_name;
                  if(typeof json.results[j].formatted_address !== "undefined")
                //if (json.results[j].address_components[i].types.includes("street_address"))
                    street_address = json.results[j].formatted_address;
                if(city !== "" && state !== "" && country !== "") break;
            }
            if(city !== "" && state !== "" && country !== "") break;
        }

          // if(json.results[0].length === 7){
            // place.Country = country;
            // place.City = city;
            // place.State = state;
            // place.Address = street_address;
          // }
          // else if(json.results.length === 4 && json.results[3].types.includes("country")){
          //   place.Country = json.results[3].formatted_addres;
          // }
          
        }catch{

        }
  })
  };

  selectCountry = () => {
    let _countries = [];
    const countries_sorted = countries.sort();
    let id = 1;
    countries_sorted.forEach((country) =>
      _countries.push({
        label: country,
        name: country,
        value: country,
        id: (id++).toString(),
      })
    );
    this.MultiSelect(_countries, [], "uni", this.selectedCountry, "Select Country");
  };

  selectedCountry = (countries) => {
    if (countries.length < 1) return;
    const country = countries[0].label;
    // Blanking the city on an actual country change (not a no-op reselect)
    // avoids leaving a stale city from the old country — city choices are
    // scoped to a country.
    const cityChanged = country !== this.state.textValueCountry;
    this.setState({
      ...this.state,
      textValueCountry: country,
      Country: countries,
      textValueCity: cityChanged ? "" : this.state.textValueCity,
    });
  };

  PLACE_CITY_OTHER = "__other__";

  // Country-first: if the country isn't picked yet, redirect there instead
  // of showing an empty/meaningless city list.
  selectCity = () => {
    const country = this.state.textValueCountry;
    if (!country) {
      this.selectCountry();
      return;
    }
    const cityList = (citiesByCountry[country] || []).slice().sort((a, b) => b.popularity - a.popularity);
    if (cityList.length === 0) {
      this._promptCityText();
      return;
    }
    const items = cityList.map((c, i) => ({ label: c.city, name: c.city, value: c.city, id: (i + 1).toString() }));
    items.push({ label: "Type a different city…", name: "other", value: this.PLACE_CITY_OTHER, id: (items.length + 1).toString() });
    this.MultiSelect(items, [], "uni", this.selectedCity, `Select a city in ${country}`);
  };

  selectedCity = (selected) => {
    if (!selected || selected.length === 0) return;
    if (selected[0].value === this.PLACE_CITY_OTHER) {
      this._promptCityText();
      return;
    }
    this.setState({ textValueCity: selected[0].value });
  };

  // Free-text fallback — for a country with no curated cities, or the
  // curated list's own "type a different city" escape hatch. No geocode
  // validation: this field also accepts non-geocodable entries like a
  // neighborhood or region, matching its existing lenient behavior.
  _promptCityText = () => {
    this.setState({
      PromptModalShow: true,
      PromptModalTitle: "City",
      PromptModalMessage: "Enter City",
      PromptModalButtons: [
        { Title: "OK", Method: this._promptCityTextCallBack },
        { Title: "CANCEL", Method: null },
      ],
      PromptModalInputs: [{ name: "City", value: this.state.textValueCity || "" }],
    });
  };

  _promptCityTextCallBack = (inputs) => {
    const city = (inputs?.[0]?.value || "").trim();
    if (city === "") return;
    this.setState({ textValueCity: city });
  };

  render() {
    const _ptype = this.state.type || "Icon";
    let placeType =
      _ptype === "Icon" ? "Location" : _ptype === "PolyLine" ? "Path" : "Area";
    if (this.state.ImageDialogShow)
      return (
        <ImageDialog
          show={this.state.ImageDialogShow}
          onHide={() => this.setState({ ImageDialogShow: false })}
          user_info={this.props.user_info}
          // callback={this.updateImageCallBack}
          mode={"select"}
          modify_only={"true"}
          updateImage={this.updateImageCallBack}
          size={"sm"}
          photo={this.state.Photo}
          photo_m={this.state.Photo_m}
          multi={false}
          exif={false}
          map_bounds={this.props.map_bounds}
          place={this.props.place}
          folder={this.props.folder}
          setImageFolder={this.props.setImageFolder}
        />
      );
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
          onEdit={this.state.MultiselectOnEdit}
        />
      );
    if (this.state.ShowGroupsDialog)
      return (
        <GroupsDialog
          show={true}
          onHide={() => { this.setState({ ShowGroupsDialog: false }); this.selectGroups(); }}
          update_display={() => {}}
        />
      );
    if (this.state.ShowCategoriesDialog)
      return (
        <CategoriesDialog
          show={true}
          onHide={() => { this.setState({ ShowCategoriesDialog: false }); this.selectCategories(); }}
          update_display={() => {}}
        />
      );
    if (this.state.PromptModalShow)
      return (
        <PromptModal
          show={this.state.PromptModalShow}
          onHide={() => this.setState({ PromptModalShow: false })}
          PromptModalTitle={this.state.PromptModalTitle}
          PromptModalMessage={this.state.PromptModalMessage}
          PromptModalButtons={this.state.PromptModalButtons}
          PromptModalInputs={this.state.PromptModalInputs}
        />
      );

    if (this.state.SectionsDialogShow)
      return (
        <SectionsDialog
          show={this.state.SectionsDialogShow}
          onHide={() => this.setState({ SectionsDialogShow: false })}
          update_display={null}
          mode={"select"}
          callback={this.selectSectionCallBack}
        />
      );

    const coordsText = this.state.Points !== null
      ? "(path)"
      : [this.state.textValueLat, this.state.textValueLongi].every((v) => { const t = String(v ?? "").trim(); return t === "" || !Number.isFinite(Number(t)); })
      ? "No map location"
      : `${this.formatLatLong(this.state.textValueLat)}, ${this.formatLatLong(this.state.textValueLongi)}`;

    return (
      <>
        <div className="modal">
          <Modal
            {...this.props}
            enforceFocus={false}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            scrollable={true}
            dialogClassName="pem-dialog"
          >
            <Modal.Header style={{ padding: 0, border: "none" }}>
              <div className="pem-header">
                <div className="pem-header-icon">
                  <FontAwesomeIcon icon={solid("location-dot")} />
                </div>
                <h2 className="pem-title">{placeType} Edit</h2>
                <button className="pem-save-btn" onClick={() => this.AddPlace()}>
                  <FontAwesomeIcon icon={solid("check")} />
                  Save
                </button>
                <button className="pem-close" onClick={() => this.exitDialog()}>
                  <FontAwesomeIcon icon={solid("xmark")} />
                </button>
              </div>
            </Modal.Header>

            <Modal.Body className="pem-body">
              <div className="pem-scroll">

                {/* Details */}
                <span className="pem-section-label">Details</span>
                <div className="pem-card">
                  {this._renderInput("Name", this.state.textValueName, this.handleChangeTextName, "Enter name")}
                  {this._renderIdentify()}
                </div>
                {this.state.mapPick ? (
                  <MapPickDialog
                    show
                    lat={this._identifyCoords()?.lat}
                    lng={this._identifyCoords()?.lng}
                    onHide={() => this.setState({ mapPick: false })}
                    onPick={(name) => this._pickIdentifiedName(name)}
                  />
                ) : null}

                {/* Flags */}
                <span className="pem-section-label">Flags</span>
                <div className="pem-card">
                  {this._renderCheck("Favorite", this.state.Favorite, () => this.FavoriteChanged())}
                  <div className="pem-divider" />
                  {this._renderCheck("Visited", this.state.Visited, () => this.VisitedChanged())}
                  <div className="pem-divider" />
                  {this._renderCheck("Must See", this.state.MustSee, () => this.MustSeeChanged())}
                  <div className="pem-divider" />
                  {this._renderCheck("Bucket List", this.state.BucketList, () => this.BucketListChanged())}
                  <div className="pem-divider" />
                  {this._renderCheck("Hidden", this.state.Hidden, () => this.HiddenChanged())}
                </div>

                {/* Location */}
                <span className="pem-section-label">Location</span>
                <div className="pem-card">
                  <div className="pem-info-row">
                    <span className="pem-info-label">Coordinates</span>
                    <span className="pem-info-value">{coordsText}</span>
                  </div>
                </div>

                {/* Media */}
                <span className="pem-section-label">Media</span>
                <div className="pem-card">
                  <div className="pem-media-preview">
                    <img
                      src={this.getImageURLString(this.state.Photo_m) || this.getImageURLString(this.state.Photo) || "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg"}
                      alt=""
                      className="pem-photo-large"
                      referrerPolicy="no-referrer"
                      onError={(e) => { e.target.onerror = null; e.target.src = "https://andiamotravelapp.com/Images/App/IllustratedImage.jpg"; }}
                    />
                  </div>
                  <div className="pem-divider" />
                  {this._renderRow("Change photo", <FontAwesomeIcon icon={solid("camera")} />, null, () => this.changeImage())}
                  {this.state.Photo || this.state.Photo_m ? (
                    <>
                      <div className="pem-divider" />
                      {this._renderRow("Clear photo", <FontAwesomeIcon icon={solid("eraser")} />, null, () => { this._photoExtras = {}; this.setState({ Photo: "", Photo_m: "" }); })}
                    </>
                  ) : null}
                  {this.state.type === "Icon" ? (
                    <>
                      <div className="pem-divider" />
                      <div className="pem-media-preview">
                        <img src={Place.getPlacePOIImage(this.state.poi_img)} className="pem-icon-large" alt="" />
                      </div>
                      <div className="pem-divider" />
                      {this._renderRow("Change icon", <FontAwesomeIcon icon={solid("bookmark")} />, null, () => this.changeIcon())}
                    </>
                  ) : null}
                </div>

                {/* Address */}
                <span className="pem-section-label">Address</span>
                <div className="pem-card">
                  {this._renderInput("Address", this.state.textValueAddress, this.handleChangeTextAddress, "Address")}
                  <div className="pem-divider" />
                  {/* Picks from the selected country's curated city list, with a
                      "type a different city" fallback — see selectCity(). */}
                  {this._renderRow("City", <FontAwesomeIcon icon={solid("location-dot")} />, this.state.textValueCity, this.selectCity)}
                  <div className="pem-divider" />
                  {this._renderInput("State", this.state.textValueState, this.handleChangeTextState, "State")}
                  <div className="pem-divider" />
                  {this._renderRow("Country", <FontAwesomeIcon icon={solid("flag")} />, this.state.textValueCountry, this.selectCountry)}
                </div>

                {/* Organization */}
                <span className="pem-section-label">Organization</span>
                <div className="pem-card">
                  {this._renderRow("Groups", <FontAwesomeIcon icon={solid("layer-group")} />, window.guide_obj.groupNamesFromIDs(this.state.Groups), this.selectGroups)}
                  <div className="pem-divider" />
                  {this._renderRow("Categories", <FontAwesomeIcon icon={solid("tag")} />, window.guide_obj.categoryNamesFromIDs(this.state.Categories), this.selectCategories)}
                </div>

                {/* Contact */}
                <span className="pem-section-label">Contact</span>
                <div className="pem-card">
                  {this._renderInput("Phone", this.state.textValuePhone, this.handleChangeTextPhone, "Phone")}
                  <div className="pem-divider" />
                  {this._renderInput("Email", this.state.textValueEmail, this.handleChangeTextEmail, "Email")}
                  <div className="pem-divider" />
                  {this._renderInput("URLs", this.state.textValueHlink, this.handleChangeTextHlink, "URLs")}
                </div>

                {/* Opening Hours */}
                <span className="pem-section-label" id="pem-opening-hours-section">Opening Hours</span>
                <div className="pem-card">
                  {Place.OPENING_HOURS_DAYS.map((day, i) => (
                    <React.Fragment key={day}>
                      {this._renderOpeningHoursRow(day)}
                      {i < Place.OPENING_HOURS_DAYS.length - 1 && <div className="pem-divider" />}
                    </React.Fragment>
                  ))}
                </div>

                {/* Link */}
                <span className="pem-section-label">Link</span>
                <div className="pem-card">
                  {this._renderRow("Place Link", <FontAwesomeIcon icon={solid("link")} />, this.state.LinkName, this.createPlaceLinkMenu)}
                  {this.state.Link.type === "video" ? (
                    <>
                      <div className="pem-divider" />
                      {this._renderInput("Video Offset (sec)", this.state.Link.offset, this.handleChangeVideoLinkOffset, "0")}
                    </>
                  ) : null}
                </div>

                {/* Advanced */}
                <span className="pem-section-label">Advanced</span>
                <div className="pem-card">
                  {this._renderInput("Rating (0-5)", this.state.textValueRating, this.handleChangeTextRating, "Rating")}
                  <div className="pem-divider" />
                  {this._renderInput("Duration (minutes to visit)", `${this.state.textValueDuration}`, this.handleChangeTextDuration, "30")}
                  <div className="pem-divider" />
                  <div className="pem-input-row">
                    <span className="pem-input-label">Best time of day</span>
                    <select
                      className="pem-input-field"
                      aria-label="Best time of day"
                      value={this.state.BestTime}
                      onChange={(e) => this.setState({ BestTime: e.target.value })}
                    >
                      <option value="">Any time</option>
                      {Place.BEST_TIMES.map((t) => (
                        <option key={t} value={t}>{t[0].toUpperCase() + t.slice(1)}</option>
                      ))}
                    </select>
                  </div>
                  <div className="pem-divider" />
                  <div style={{ padding: "10px 14px" }}>
                    <div className="ee-section-label" style={{ marginBottom: 6 }}>Notes</div>
                    {/* Preview + Edit button: the editor starts only on Edit
                        (each start counts toward the TinyMCE plan). */}
                    <NotesPreview html={this.state.textValueInfoUpdate} title="Notes" onChange={this.editInfoCallback} />
                  </div>
                </div>

                {/* Comments */}
                {this.props.mode !== "ADD" && this.props.place.ID ? (
                  <CommentsSection targetType="place" item={this.props.place} />
                ) : null}

              </div>
            </Modal.Body>
          </Modal>
        </div>

        <AlertModal
          show={this.state.AlertModalShow}
          onHide={() => this.setState({ AlertModalShow: false })}
          AlertModalTitle={this.state.AlertModalTitle}
          AlertModalMessage={this.state.AlertModalMessage}
          AlertModalButtons={this.state.AlertModalButtons}
        />
        <IconsDialog
          show={this.state.IconsDialogShow}
          onHide={() => this.setState({ IconsDialogShow: false })}
          update_icon={this.changeIconCallback}
        />
        <HTMLLinksModalClass
          show={this.state.ShowHTMLLinks}
          onHide={() => this.setState({ ShowHTMLLinks: false })}
          callback={this.insertLinkCallback}
          user_info={this.props.user_info}
          guide_meta={this.props.guide_meta}
          guide_type={"Guide"}
          folder={this.props.folder}
          setImageFolder={this.props.setImageFolder}
        />
        {this.state.MenuModalShow ? (
          <MenuModal
            id="MenuModal"
            show={this.state.MenuModalShow}
            onHide={() => this.setState({ MenuModalShow: false })}
            menu_modal_list={this.state.MenuModalList}
            menu_modal_heading={this.state.MenuModalHeading}
            menu_model_image={this.state.MenuModalImage}
            menu_modal_place={this.state.MenuModalPlace}
          />
        ) : null}
      </>
    );
  }
}

export default PlaceEditModal;
